import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Helmet } from 'react-helmet';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { fi } from 'date-fns/locale';
import { formatDateToYYYYMMDDWithoutTime } from '../../common/utils/dateUtils';
import { Loader, SectionHeader } from '../../common/components';
import { useAppDispatch } from '../../app/hooks';
import {
  generatePreSellStatsAsync,
  PreSellStatsCommand,
} from './accountingSlice';

function PreSellStats() {
  const dispatch = useAppDispatch();
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedCheckBox, setSelectedCheckBox] = useState(false);
  const [selectedCheckBox2, setSelectedCheckBox2] = useState(false);
  const [selectedCheckBox3, setSelectedCheckBox3] = useState(false);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);

  const [createdStartDate, setCreatedStartDate] = useState<Date | null>(null);
  const [createdEndDate, setCreatedEndDate] = useState<Date | null>(null);

  const [bookingNumber, setBookingNumber] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {}, []);
  useEffect(() => {
    if (
      selectedStartDate &&
      selectedEndDate &&
      createdStartDate &&
      createdEndDate
    ) {
      setError(null);
    }
  }, [selectedStartDate, selectedEndDate, createdStartDate, createdEndDate]);
  const sellStatsCommandHandle = async () => {
    if (
      !selectedStartDate ||
      !selectedEndDate ||
      !createdStartDate ||
      !createdEndDate
    ) {
      setError(
        'Valitse varaus voimassa alkupäivä ja loppupäivä, sekä varaus luotu alku ja loppupäivät',
      );
      return;
    }
    setIsLoading(true);
    try {
      const command = {
        startDate: formatDateToYYYYMMDDWithoutTime(selectedStartDate),
        endDate: formatDateToYYYYMMDDWithoutTime(selectedEndDate),
        createdEndDate: formatDateToYYYYMMDDWithoutTime(createdEndDate),
        createdStartDate: formatDateToYYYYMMDDWithoutTime(createdStartDate),
        errorDetection: selectedCheckBox,
        errorDetection2: selectedCheckBox2,
        errorDetection3: selectedCheckBox3,
        bookingNumber,
      } as PreSellStatsCommand;

      await dispatch(generatePreSellStatsAsync(command));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Ennakkomyyntikirja - Luonti</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Ennakkomyyntikirja']}
          Title="Ennakkomyyntikirjan luonti"
        />
        <Container className="container-form">
          {error && (
            <Alert className="mb-32" variant="danger">
              {error}
            </Alert>
          )}

          {/* <Form.Group controlId="start" className="mb-24"> */}
          {/*  <Form.Label> */}
          {/*    Sisällytä virheen etsintä(Käytetään ennen yliheittoa alustavana */}
          {/*    olleita listaa && tarkistetaan Laskunpv ja verrataan */}
          {/*    muokkauspäivään ja mahdollisesti peruutuspäivään) */}
          {/*  </Form.Label> */}
          {/*  <input */}
          {/*    type="checkbox" */}
          {/*    onChange={date => setSelectedCheckBox(!selectedCheckBox)} */}
          {/*    checked={selectedCheckBox} */}
          {/*  /> */}
          {/* </Form.Group> */}
          {/* <Form.Group controlId="start" className="mb-24"> */}
          {/*  <Form.Label> */}
          {/*    Käytä Laskun päivystä varauksen luontihetken sijaan */}
          {/*  </Form.Label> */}
          {/*  <input */}
          {/*    type="checkbox" */}
          {/*    onChange={date => setSelectedCheckBox3(!selectedCheckBox3)} */}
          {/*    checked={selectedCheckBox3} */}
          {/*  /> */}
          {/* </Form.Group> */}
          <Form.Group
            controlId="start"
            className="mb-24 d-flex align-items-center"
          >
            <Form.Label className="m-0">
              Sisällytä virheen etsintä Varauksen luontipäivänä käytetään Laskun
              luontipäivää
            </Form.Label>
            <input
              type="checkbox"
              onChange={date => setSelectedCheckBox2(!selectedCheckBox2)}
              checked={selectedCheckBox2}
              className="ms-2"
            />
          </Form.Group>
          <Form.Group
            controlId="start"
            className="mb-24 d-flex align-items-center"
          >
            <Form.Label className="m-0" style={{ minWidth: '200px' }}>
              Raportin alkupäivä(Varaus voimassa)
            </Form.Label>
            <DatePicker
              locale={fi}
              required
              dateFormat="dd.MM.yyyy"
              showYearDropdown
              onChange={date => setSelectedStartDate(date)}
              selected={selectedStartDate}
              id="start"
            />
          </Form.Group>
          <Form.Group
            controlId="end"
            className="mb-24 d-flex align-items-center"
          >
            <Form.Label className="m-0" style={{ minWidth: '200px' }}>
              Raportin loppupäivä(Varaus voimassa)
            </Form.Label>
            <DatePicker
              locale={fi}
              required
              dateFormat="dd.MM.yyyy"
              showYearDropdown
              onChange={date => setSelectedEndDate(date)}
              selected={selectedEndDate}
              id="end"
            />
          </Form.Group>
          <Form.Group
            controlId="createdStart"
            className="mb-24 d-flex align-items-center"
          >
            <Form.Label className="m-0" style={{ minWidth: '200px' }}>
              Varaus luotu alkupäivä
            </Form.Label>
            <DatePicker
              locale={fi}
              required
              dateFormat="dd.MM.yyyy"
              showYearDropdown
              onChange={date => setCreatedStartDate(date)}
              selected={createdStartDate}
              id="createdStart"
            />
          </Form.Group>
          <Form.Group
            controlId="createdEnd"
            className="mb-24 d-flex align-items-center"
          >
            <Form.Label className="m-0" style={{ minWidth: '200px' }}>
              Varaus luotu loppupäivä
            </Form.Label>
            <DatePicker
              locale={fi}
              required
              dateFormat="dd.MM.yyyy"
              showYearDropdown
              onChange={date => setCreatedEndDate(date)}
              selected={createdEndDate}
              id="createdEnd"
            />
          </Form.Group>
          <Form.Group
            controlId="number"
            className="mb-24 d-flex align-items-center"
          >
            <Form.Label className="m-0" style={{ minWidth: '200px' }}>
              Varausnumero(valinnainen). Yksittäisen varauksen tarkasteluun
            </Form.Label>
            <input
              onChange={text => setBookingNumber(text.target.value)}
              className="form-control"
              value={bookingNumber}
              id="number"
              style={{ maxWidth: '300px' }}
            />
          </Form.Group>
          <Button
            onClick={sellStatsCommandHandle}
            variant="primary"
            className="w-100 mt-16"
            disabled={isLoading}
          >
            {isLoading ? (
              <>Luodaan Ennakkomyyntikirjaa...</>
            ) : (
              'Luo Ennakkomyyntikirja'
            )}
          </Button>
          {isLoading && (
            <div className="my-24">
              <Loader IsLoading />
            </div>
          )}
        </Container>
        {/* <Button */}
        {/*  onClick={downloadWintime} */}
        {/*  size="sm" */}
        {/*  variant="outline-blue" */}
        {/*  className="px-16" */}
        {/* > */}
        {/*  Lataa wintime aineisto Zip tiedostona */}
        {/* </Button> */}
      </Container>
    </>
  );
}

export default PreSellStats;
